const emojiList = [
  '🙂',
  '😉',
  '😄',
  '🤣',
  '😋',
  '🤔',
  '🙄',
  '😎',
  '😕',
  '😡',
  '💗',
  '👍',
  '👎',
  '🙈',
  '🙉',
  '🙊',
]

export default function useEmojis() {
  return {
    emojiList,
  }
}
